import React, { useEffect, useState } from "react";
import "./EnvComponent.scss"; // Import SCSS file
import Home from "../Home/Home";
import { CartData } from "../../interfaces/CartData";
import { useNavigate } from "react-router-dom";
import { useHeaderMenu } from "../../contexts/login.context";
import useLoader from '../../contexts/LoaderContext';
import Spinner from "../Spinner/Spinner";
import { useTranslation } from "react-i18next";
import nvCookieHelpers from "../../services/cookieService";
import { useCart } from "../../services/cartService";
import { config } from "../../config";
import { useAuth } from '../../services/authService';

const EnvComponent = () => {
  const [data, setData] = useState<CartData | null>(null);
  const locale = window.location.pathname.split('/')[1];
  const { showLoader, hideLoader, isLoading, hideBodyLoader } = useLoader();
  const { setIsDownload, setIsPartner, setItemsInCart, setIsDirect, isPartner, isDirect } = useHeaderMenu();
  const { getCart } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isVerify: boolean = false;
  const isThanks: boolean = false;
  const { HandleSSOLogin } = useAuth();
  const [loggedIn, setLoggedIn] = useState(false);
  const registeredShopperAPI = config.registeredShopperAPI;
  const emptyCart = (msg, pid?) => navigate(`/${locale}/software/cart/empty`, { state: { msg, pid } });
  const orderAccount = () => {
    if (isPartner) {
      if (isDirect) {
        window.location.href = config.bcDirectOrdersUrl
      } else {
        window.location.href = config.bcOrdersUrl
      }
    }
  }

  const handleSuccess = (result, pid?) => {
    let resultLength = Object.keys(result.cartItems).length
    if (result && resultLength > 0) {
      setData(result)
      if (result.partner) {
        setIsPartner(result.partner);
        setIsDirect(result.isDirect);
      } else {
        setIsPartner(false);
        setIsDirect(false);
      }
      setIsDownload(result.isDigital);

    } else {
      let cartState, customatts, matchingNames;
      let orderObj = nvCookieHelpers.getCookie('nvHeadless');
      let tmpcart = orderObj ? orderObj['cart'] : [];
      cartState = result["cartItems"]["cartItem"];
      customatts = result?.customAttributes?.attribute;

      if (customatts) {
        for (let i = 0; i < customatts.length; i++) {
          if (customatts[i].name === 'message_driver' && tmpcart) {
            // Split the string using the semicolon as the delimiter
            let idsToMatch = customatts[i].value.split(';').map(id => parseInt(id, 10));
            matchingNames = tmpcart.filter(item => idsToMatch.includes(item.id)).map(item => ({ id: item.id, name: item.name }));
            // Log the extracted values
            // Insert each matching name into cartState array using the external function
            if (!isThanks && !isVerify) {
              if (!cartState) {
                let str: string;
                if (matchingNames && matchingNames.length > 1) {
                  str = "We're sorry, the products you are trying to purchase are currently out of stock.";
                } else {
                  str = "We're sorry, " + matchingNames[0]['name'] + " is currently out of stock."
                }
                emptyCart(str, Number(idsToMatch));
              }
            }
          };
        }
      } else {
        if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
          orderAccount();
        } else {
          handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'), pid);
        }
      }
    }
    // hideLoader();
  }
  const handleError = (str: string, pid?: number) => {
    if (pid) {
      if (str && str.length) {
        emptyCart(str, pid);
      } else {
        emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'), pid);
      }
    } else {
      emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
    }
    setItemsInCart(0);
    hideBodyLoader();
  };
  const handleSubmit = (btnType: string) => {
    if (btnType) {
      navigate(`/${locale}/software/cart/user/${btnType}`);
      sessionStorage.setItem('customer', btnType);
    } else {
      // Navigate to another route
      navigate(`/${locale}/software/cart/`);
    }
  };
  useEffect(() => {
    async function fetchData() {
      try {
        showLoader();
        fetch(registeredShopperAPI, {
          credentials: 'include',
        }).then(async (res) => {
          await HandleSSOLogin(handleSubmit, () => { })
          await getCart(handleSuccess, handleError, true);
          const isUserLoggedIn = nvCookieHelpers.getCookie('isUserLoggedIn');
          if (isUserLoggedIn && Boolean(isUserLoggedIn)) {
            setLoggedIn(true);
            hideLoader();
          } else {
            const userEmail = nvCookieHelpers.getCookie('dli_marketplace_id')?.replace(/^"|"$/g, '');
            if (userEmail && !isUserLoggedIn) {
              nvCookieHelpers.deleteCookie('dli_marketplace_id');
              window.location.href = config.bcSSOLoginUrl.replace('/authorize?', `/authorize?login_hint=${userEmail}&`) + `${locale}/software/cart`;
            } else {
              hideLoader();
            }
          }

        });

      } catch (error) {
        console.error(error);
        //hideLoader();
        emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
      }
    }
    if (!data) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="env-component">
      {
        isLoading ? (
          <Spinner />
        ) : (
          <div className="viewPage">
            {data && (
              <Home cartData={data} loggedIn={loggedIn} />
            )}
          </div>
        )}
    </div>
  );

}

export default EnvComponent;
